module.exports = __webpack_public_path__ + "img/check-circle.529f8e23.svg";